import { getQualifiedResourcesFNOLFeature } from '@dispatch/shared/services';
import { useQuery } from '../useQuery';
import { isEmpty } from 'lodash';

export const useGetQualifiedResourcesFNOLFeature = (
  tenantId: string,
  enabled = true
) => {
  const { data, status, refetch } = useQuery(
    ['qualified-resources-fnol-feature'],
    () => getQualifiedResourcesFNOLFeature(tenantId),
    {
      enabled: enabled && !isEmpty(tenantId),
    }
  );

  return {
    feature: data || false,
    featureStatus: status,
    fetchFeature: refetch,
  };
};
